import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { MessService } from '../mess.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';

@Component({
  selector: 'app-mess-list',
  templateUrl: './mess-list.component.html',
  styleUrls: ['./mess-list.component.scss']
})
export class MessListComponent implements OnInit {
  @ViewChild('searchInputcampus') searchInputcampus!: ElementRef;
  campusQuery: string = '';

  KitchenType: any = '';
  selectDate: string = '';
  selectedFile!: File;
  fileName: string = '';
  messDate: any;
  allocatedCampusList: any;
  filteredCampusDetails: any;

  selectedBuildingName: any;
  selectedBuildingID: any;
  buildingValue: any;
  // fileName: any;
  constructor(private service: MessService, private spinner: NgxSpinnerService, private toast: ToastmessageService,) { }
  ngOnInit(): void {
    this.allocatedCampus();
  }

  allocatedCampus() {
    this.spinner.show();
    this.service.getAllocatedcampus().subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.allocatedCampusList = res;
        console.log('  this.allocatedCampusList', this.allocatedCampusList);
        this.campusQuery = '';
        this.filteredCampusDetails = this.allocatedCampusList;
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }

  selectCampus(buildingName: any, buildingId: any): void {
    this.filteredCampusDetails = this.allocatedCampusList;
    this.selectedBuildingName = buildingName;
    this.selectedBuildingID = buildingId;
    this.campusQuery = ''
  }

  focusSearchInput() {
    setTimeout(() => {
      if (this.searchInputcampus) {
        this.searchInputcampus.nativeElement.focus();
      }
    }, 100);
  }

  campusSearch(item: any) {
    this.buildingValue = (item.target as HTMLInputElement).value;
    if (this.buildingValue) {
      this.filteredCampusDetails = this.allocatedCampusList.filter((building: any) =>
        building.buildingName.includes(this.buildingValue) ||
        building.buildingName.toLowerCase().includes(this.buildingValue.toLowerCase())
      );
    } else {
      this.filteredCampusDetails = this.allocatedCampusList;
    }
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const allowedTypes = [
        'application/vnd.ms-excel', // .xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'text/csv' // CSV
      ];

      if (!allowedTypes.includes(file.type)) {
        alert('Only Excel files (.xls, .xlsx, .csv) are allowed.');
        return;
      }
      this.selectedFile = file;
      this.fileName = file.name;
    }
  }

  onStockDateChange(event: any) {
    this.selectDate = moment(event.value).format("DD MMM YYYY");
    console.log(' this.selectDate', this.selectDate);
  }


  submit() {
    if (!this.selectedFile) {
      alert("Please select a file before submitting.");
      return;
    }
    const formData = new FormData();
    formData.append("file", this.selectedFile);
    formData.append("date", this.selectDate);
    formData.append("payrollId", "HYD103135");

    this.spinner.show();
    this.service.postUploadMess(formData).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.messDate = res;
        this.toast.showSuccess(res);
        console.log('messDate', this.messDate);
        this.selectedFile = undefined as any;
        this.fileName = '';
        const fileInput = document.getElementById('fileInput') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = ''; // reset the input field
        }
        this.spinner.hide();
      },
      error: (err: any) => {
        console.log('Upload failed:', err);
        this.toast.showError(err);
        this.spinner.hide();
      }
    });
  }


}
